import React, { useEffect, useRef, useState } from "react";
import { productPlaceholder, secondaryProductPlaceholder } from "../../data/products";
import ProductImage from "./ProductImage";

const HOVER_MEDIA = "(min-width: 768px) and (hover: hover) and (pointer: fine)";

export default function ProductCardImage({ images = [] }) {
  const containerRef = useRef(null);
  const [loadSecondary, setLoadSecondary] = useState(false);
  const [readySrc, setReadySrc] = useState(null);
  const primary = images[0] || productPlaceholder;
  // Placeholder layers must not cover a real photo or participate in hover swaps.
  const secondary = images[1]
    && images[1].src !== productPlaceholder.src
    && images[1].src !== secondaryProductPlaceholder.src
    ? images[1]
    : null;

  useEffect(() => {
    setLoadSecondary(false);
    if (!secondary || typeof window.matchMedia !== "function") return undefined;
    const media = window.matchMedia(HOVER_MEDIA);
    let observer;
    const prepareSecondary = () => {
      observer?.disconnect();
      if (!media.matches) {
        setLoadSecondary(false);
      } else if (typeof IntersectionObserver === "undefined") {
        setLoadSecondary(true);
      } else {
        // Warm just the second image shortly before the card enters view.
        observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            setLoadSecondary(true);
            observer.disconnect();
          }
        }, { rootMargin: "200px" });
        observer.observe(containerRef.current);
      }
    };
    prepareSecondary();
    media.addEventListener("change", prepareSecondary);
    return () => {
      observer?.disconnect();
      media.removeEventListener("change", prepareSecondary);
    };
  }, [secondary]);

  return (
    <div ref={containerRef} className={`product-card-image${loadSecondary && readySrc === secondary?.src ? " is-secondary-ready" : ""}`}>
      {/* Start this page's main photos immediately and decode them with the paint. */}
      <ProductImage image={primary} eager decoding="sync" className="product-card-image-primary" />
      {loadSecondary && secondary && (
        <ProductImage key={secondary.src} image={secondary} eager decorative
          className="product-card-image-secondary" onLoad={(event) => {
            // A fallback placeholder loading successfully must not enable the swap.
            if (event.currentTarget.getAttribute("src") === secondary.src) {
              setReadySrc(secondary.src);
            }
          }} />
      )}
    </div>
  );
}
